import React from 'react';
import './OverlayClose.css';
import { NavLink } from 'react-router-dom';


import CloseIcon from '@mui/icons-material/Close';

class OverlayClose extends React.Component {
    render() {
        return (
            <NavLink to="/" className="overlay-close" onClick={this.props.closeOverlay}>
                <CloseIcon className="overlay-close-icon" />
                <span className="overlay-close-text">Close</span>
            </NavLink>
        );
    }
}

export default OverlayClose;